/**
 * Appends a query string to an href built by `router.buildLocation`, for tree
 * routes that declare no `validateSearch`. TanStack's default search
 * serializer JSON-quotes numeric-looking strings (`id=5` becomes `id=%225%22`),
 * so the query is written with `URLSearchParams` instead. Null and undefined
 * values are dropped, as `generatePath` did.
 */
export function appendQuery(
  href: string,
  query?: Record<string, string | number | boolean | undefined | null>,
): string {
  const searchParams = new URLSearchParams();
  if (query != null) {
    for (const [key, value] of Object.entries(query)) {
      if (value != null) {
        searchParams.set(key, String(value));
      }
    }
  }
  const search = searchParams.toString();
  return search.length > 0 ? `${href}?${search}` : href;
}
